var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import Components from './components';
import Pages from './pages';
import './yt-video';
import store from './store';
Vue.config.productionTip = false;
Vue.config.devtools = false;
Vue.use(Vue2TouchEvents);
var elems = document.querySelectorAll(".v-cloak");
[].forEach.call(elems, function (el) {
    el.className = el.className.replace(/\bv-cloak\b/, "");
});
var app = new Vue({
    el: '#app',
    store: store,
    data: {},
    components: __assign(__assign({}, Components), Pages)
});
window.openWhatsapp = function (phone, message, property) {
    store.commit('openWhatsappModal', {
        phone: phone,
        message: message,
        propertyCod: (property === null || property === void 0 ? void 0 : property.propertyCod) || '',
        propertyMessage: (property === null || property === void 0 ? void 0 : property.propertyMessage) || '',
        propertyFinality: (property === null || property === void 0 ? void 0 : property.propertyFinality) || 'sale',
    });
};
